export const defaultCollectionTypes = {
  recent: 'recent',
  favorites: 'favorites'
};
